// REFACTOR-025 (Sprint 14): comparatore di ordinamento condiviso tra la vista
// lista (MainPanel → recycle-scroller, ordina per `sortAction`) e il default
// della vista tabella (TrucksTable, quando nessuna colonna è attiva).
// Prima la logica era duplicata: `listActiveTrucks` ordinava per sortAction e poi
// la tabella ri-ordinava → doppio sort sugli stessi dati ad ogni tick.
//
// `resolvePath` è iniettato come parametro perché vive su `Vue.prototype`
// (src/plugins/Utilities.js) e non è importabile come funzione pura.
// `criteria` = array di { key: [primary, fallback], order: 'asc' | 'desc' }.

function compareByKey({ key, order = 'asc' }, a, b, resolvePath) {
    const varA = resolvePath(key[0], a) || resolvePath(key[1], a)
    const varB = resolvePath(key[0], b) || resolvePath(key[1], b)

    let comparison = 0
    if (varA > varB) {
        comparison = 1
    } else if (varA < varB) {
        comparison = -1
    }

    if (order === 'desc') {
        comparison *= -1
    }

    return comparison
}

export function sortByKey(criteria, resolvePath) {
    return (a, b) => {
        let returnValue = 0
        criteria.find((c) => (returnValue = compareByKey(c, a, b, resolvePath)))
        return returnValue
    }
}
